<!-- =========================================
     SANGEETHA TOYS — ENHANCED FOOTER
========================================= -->

<footer class="footer-area">

    <!-- ── TOP WAVE DIVIDER ── -->
    <div class="footer-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="#f0f4ff"/>
        </svg>
    </div>

    <!-- ── MAIN FOOTER BODY ── -->
    <div class="footer-body">
        <div class="container">
            <div class="row gy-5">

                <!-- COL 1: BRAND -->
                <div class="col-lg-4 col-md-12">
                    <div class="footer-brand">

                        <a routerLink="/" class="footer-logo" aria-label="Sangeetha Toys Home">
                            <div class="footer-logo__wrap">
                                <img src="assets/img/slider/mainlogo1.png" alt="Sangeetha Toys logo">
                            </div>
                        </a>

                        <p class="footer-brand__tagline">
                            Bringing joy, learning and smiles to every child.<br>
                            Thank you for choosing <strong>Sangeetha Toys!</strong> 💙
                        </p>

                        <!-- Social links -->
                        <div class="footer-social" role="list" aria-label="Social media links">
                            <a href="https://www.facebook.com/" target="_blank" rel="noopener"
                               class="footer-social__btn footer-social__btn--fb" role="listitem" aria-label="Facebook">
                                <i class='bx bxl-facebook'></i>
                            </a>
                            <a href="https://www.instagram.com/" target="_blank" rel="noopener"
                               class="footer-social__btn footer-social__btn--ig" role="listitem" aria-label="Instagram">
                                <i class='bx bxl-instagram'></i>
                            </a>
                            <a href="https://wa.me/" target="_blank" rel="noopener"
                               class="footer-social__btn footer-social__btn--wa" role="listitem" aria-label="WhatsApp">
                                <i class='bx bxl-whatsapp'></i>
                            </a>
                            <a href="https://www.youtube.com/" target="_blank" rel="noopener"
                               class="footer-social__btn footer-social__btn--yt" role="listitem" aria-label="YouTube">
                                <i class='bx bxl-youtube'></i>
                            </a>
                        </div>

                    </div>
                </div>

                <!-- COL 2: QUICK LINKS -->
                <div class="col-lg-2 col-sm-6 col-6">
                    <div class="footer-col">
                        <h4 class="footer-col__title">Quick Links</h4>
                        <ul class="footer-col__list">
                            <li><a routerLink="/">Home</a></li>
                            <li><a routerLink="/menu">Products</a></li>
                            <li><a routerLink="/about">About Us</a></li>
                            <li><a routerLink="/contact">Contact Us</a></li>
                           
                        </ul>
                    </div>
                </div>

                <!-- COL 3: CUSTOMER SERVICE -->
                <div class="col-lg-2 col-sm-6 col-6">
                    <div class="footer-col">
                        <h4 class="footer-col__title">Customer Service</h4>
                        <ul class="footer-col__list">
                            <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                            <li><a routerLink="/return-policy">Return &amp; Refund</a></li>
                            <li><a routerLink="/faq">FAQ</a></li>
                            <li><a routerLink="/terms-and-conditions">Terms &amp; Conditions</a></li>
                        </ul>
                    </div>
                </div>

                <!-- COL 4: CONTACT US -->
                <div class="col-lg-4 col-md-12">
                    <div class="footer-col">
                        <h4 class="footer-col__title">Contact Us</h4>

                        <ul class="footer-contact">

                            <li class="footer-contact__item">
                                <div class="footer-contact__icon-wrap">
                                    <i class='bx bx-map'></i>
                                </div>
                                <div>
                                    <span class="footer-contact__label">Our Address</span>
                                    <span class="footer-contact__value">
                                        123, Main Road,<br>Coimbatore, Tamil Nadu
                                    </span>
                                </div>
                            </li>

                            <li class="footer-contact__item">
                                <div class="footer-contact__icon-wrap">
                                    <i class='bx bx-phone'></i>
                                </div>
                                <div>
                                    <span class="footer-contact__label">Call Us</span>
                                    <a href="tel:+919876543210" class="footer-contact__value footer-contact__value--link">
                                        +91 98765 43210
                                    </a>
                                </div>
                            </li>

                            <li class="footer-contact__item">
                                <div class="footer-contact__icon-wrap">
                                    <i class='bx bx-envelope'></i>
                                </div>
                                <div>
                                    <span class="footer-contact__label">Email Us</span>
                                    <a href="mailto:info@sangeethatoys.com" class="footer-contact__value footer-contact__value--link">
                                        info&#64;sangeethatoys.com
                                    </a>
                                </div>
                            </li>

                            <li class="footer-contact__item">
                                <div class="footer-contact__icon-wrap">
                                    <i class='bx bx-time-five'></i>
                                </div>
                                <div>
                                    <span class="footer-contact__label">Working Hours</span>
                                    <span class="footer-contact__value">Mon – Sat: 9:00 AM – 8:00 PM</span>
                                </div>
                            </li>

                        </ul>

                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- ── COPYRIGHT BAR ── -->
    <div class="copyright-bar">
        <div class="container">
            <div class="copyright-bar__inner">

                <p class="copyright-bar__text">
                    © {{ currentYear }} <strong>Sangeetha Toys.</strong> All rights reserved.
                </p>

                <!-- Payment icons -->
                <div class="payment-icons" aria-label="Accepted payment methods">
                <img src="assets/img/payment_logo/visa.png" alt="Visa" class="payment-logo">
                <img src="assets/img/payment_logo/mastercard.png" alt="Mastercard" class="payment-logo">
                <img src="assets/img/payment_logo/upi.png" alt="UPI" class="payment-logo">
                <!-- <img src="assets/images/payments/paytm.png" alt="Paytm" class="payment-logo"> -->
                <!-- <img src="assets/images/payments/gpay.png" alt="Google Pay" class="payment-logo"> -->
                <img src="assets/img/payment_logo/rupay.png" alt="RuPay" class="payment-logo">
            </div>

                <p class="copyright-bar__dev">
                    Developed by <a href="https://fuestech.com/" target="_blank" rel="noopener">Fues Technology Solutions</a>
                </p>

            </div>
        </div>
    </div>

</footer>

<!-- ── MODALS (unchanged) ── -->

<div class="sidebarModal modal right fade" id="sidebarModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-bs-dismiss="modal"><i class='bx bx-x'></i></button>
            <div class="modal-body">
                <div class="logo">
                    <a href="index.html" class="d-inline-block"><img src="assets/img/logo.png" alt="Logo"></a>
                </div>
                <div class="sidebar-contact-info">
                    <h2>
                        <a href="tel:+919876543210">+91 98765 43210</a>
                        <span>OR</span>
                        <a href="mailto:info@sangeethatoys.com">info&#64;sangeethatoys.com</a>
                    </h2>
                </div>
                <ul class="social-list">
                    <li><span>Follow Us On:</span></li>
                    <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                    <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    <li><a href="#" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="modal fade productsQuickView" id="productsQuickView" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><i class='bx bx-x'></i></span>
            </button>
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="products-image">
                        <img src="assets/img/products/products1.jpg" alt="Product image">
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="products-content">
                        <h3>Product Name</h3>
                        <div class="price">
                            <span class="new-price">₹699</span>
                        </div>
                        <div class="products-add-to-cart">
                            <div class="input-counter">
                                <span class="minus-btn"><i class='bx bx-minus'></i></span>
                                <input type="text" value="1" min="1">
                                <span class="plus-btn"><i class='bx bx-plus'></i></span>
                            </div>
                            <button type="submit" class="default-btn"><i class='bx bx-cart'></i> ADD TO CART</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>